import { apiClient } from '../httpClient';
import { handleApiError } from '../utils/errorHandler';

export const userService = {
  // 사용자 목록 조회
  getUsers: async () => {
    try {
      const response = await apiClient.get('/user/v1/list');
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, '사용자 목록을 가져오는데 실패했습니다.');
    }
  },

  // 사용자 승인
  approveUser: async (userId) => {
    try {
      const response = await apiClient.put('/user/v1/modify', {
        user_id: userId,
        approval: 1
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, '사용자 승인에 실패했습니다.');
    }
  },

  // 사용자 거부
  rejectUser: async (userId) => {
    try {
      const response = await apiClient.put('/user/v1/modify', {
        user_id: userId,
        approval: 2
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, '사용자 거부에 실패했습니다.');
    }
  },

  // 로그인 로그 조회
  getLoginLogs: async (params = {}) => {
    try {
      const defaultParams = {
        limit: 500,
        ...params
      };

      const response = await apiClient.get('/user/v1/login_logs', {
        params: defaultParams
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, '로그인 로그를 가져오는데 실패했습니다.');
    }
  },

  // 비밀번호 재설정
  resetPassword: async (userId, newPassword) => {
    try {
      const response = await apiClient.post(`/user/v1/reset_password/${userId}`);
      console.log("[API] resetPassword response", response);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, '비밀번호 재설정에 실패했습니다.');
    }
  },

  // 메시지 전송
  sendMessage: async (messageData) => {
    try {
      const response = await apiClient.post('/user/v1/message', messageData);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, '메시지 전송에 실패했습니다.');
    }
  },

  /** 공개 사용자 정보 (이메일 등) — GET /user/v1/public/{user_id} */
  getUserPublic: async (userId) => {
    const uid = typeof userId === 'string' ? userId.trim() : '';
    if (!uid) {
      return { success: false, error: { message: 'user_id is required' } };
    }
    try {
      const response = await apiClient.get(
        `/user/v1/public/${encodeURIComponent(uid)}`
      );
      return { success: true, data: response.data };
    } catch (error) {
      if (error?.response?.status === 404) {
        return { success: false, notFound: true };
      }
      return handleApiError(error, '사용자 정보를 가져오는데 실패했습니다.');
    }
  },

  // 내정보 조회
  getMyInfo: async () => {
    try {
      const response = await apiClient.get('/user/v1/me');
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, '내정보 조회에 실패했습니다.');
    }
  },

  // 내정보 수정
  modifyMyInfo: async (data) => {
    try {
      console.log("[API] modifyMyInfo data", data);
      const response = await apiClient.put('/user/v1/modify', data);
      console.log("[API] modifyMyInfo response", response);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, '내정보 수정에 실패했습니다.');
    }
  }
}; 
export default userService;